import { render, staticRenderFns } from "./EventStudent.vue?vue&type=template&id=fce7cac6"
import script from "./EventStudent.vue?vue&type=script&lang=js"
export * from "./EventStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports